<script>
import Constants from '../constants';

import commonNav from '@/components/commonNav';
import commonFooter from '@/components/commonFooter';
import moveTextHover from '@/components/moveTextHover';
import vueTwitter from '@/components/vueTwitter';
// import vueBluesky from '@/components/vueBluesky.vue';
// import vueThreads from '@/components/vueThreads.vue';
import vueInstagram from '@/components/vueInstagram';
import whatsNews from '@/components/whatsNews';
import cdSliderDiamond from '@/components/cdSliderDiamond';
import cdListInformation from '@/components/cdListInformation';
import movePageOnSwipe from '@/components/movePageOnSwipe';
import youtubeContainer from '@/components/youtubeContainer';
import youtubeContainerShorts from '@/components/youtubeContainerShorts';
import eventList from '@/components/eventList';
import shareBtn from '@/components/shareBtn';
import commonParallaxItem from '@/components/commonParallaxItem';
import demoCdList from '@/components/demoCdList';
import snsIcons from '@/components/snsIcons';
import demoBoothBanner from '@/components/demoBoothBanner.vue';

import setMetaUtil from '@/util/setMetaUtil';

// import {imagesLoad} from '@/util/assetLoadUtil';

// import bandLogo from '@/assets/img/common/bandLogo.svg';
// import information01 from '@/assets/img/decoration/information01.svg';
// import information02 from '@/assets/img/decoration/information02.svg';


export default {
  name: Constants.ROUTER.INDEX,
  components: {
    commonNav,
    commonFooter,
    moveTextHover,
    vueTwitter,
    // vueBluesky,
    // vueThreads,
    vueInstagram,
    whatsNews,
    cdListInformation,
    cdSliderDiamond,
    movePageOnSwipe,
    // recentlySoundCloud,
    youtubeContainer,
    youtubeContainerShorts,
    eventList,
    shareBtn,
    commonParallaxItem,
    demoCdList,
    snsIcons,
    demoBoothBanner,
  },
  data() {
    return {
      ready: false,
      isTop: true,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
      leftMoveto: { name: Constants.ROUTER.DISCOGRAPHY },
      instagramPosts: [],
    };
  },
  async created() {
    this.ready = false;
    setMetaUtil.setMeta(this, document,
      `${this.$i18n.messages.ja.message.bandName}`,
      this.$i18n.messages.ja.message.description,
    );
    document.dispatchEvent(new Event('custom-render-trigger'));
    
    window.onscroll = () => { this.onscroll(); }
    window.onresize = () => { this.onscroll(); }
    this.onscroll();

    this.instagramPosts = [
      ...Constants.INSTAGRAM_POSTS.DRUM_MOVIE,
      ...Constants.INSTAGRAM_POSTS.BOOTH,
      ...Constants.INSTAGRAM_POSTS.DRUM_IMG,
      ...Constants.INSTAGRAM_POSTS.BASS_IMG,
      ...Constants.INSTAGRAM_POSTS.GUITAR_IMG,
      // ...Constants.INSTAGRAM_POSTS.ALBUM14,
      // ...Constants.INSTAGRAM_POSTS.ALBUM14_2,
      // ...Constants.INSTAGRAM_POSTS.ALBUM14_3,
      ...Constants.INSTAGRAM_POSTS.ALBUM14_4,
      ...Constants.INSTAGRAM_POSTS.ALBUM14_5,
      ...Constants.INSTAGRAM_POSTS.ALBUM14_6,
      ...Constants.INSTAGRAM_POSTS.ALBUM15_DEMO,
      ...Constants.INSTAGRAM_POSTS.BANDCAMP,
      ...Constants.INSTAGRAM_POSTS.EXPLANATION,
      ...Constants.INSTAGRAM_POSTS.ETC,
    ];

    // await imagesLoad([
    //   bandLogo,
    //   information01,
    //   information02,
    // ]);

    setTimeout(()=> {
      this.ready = true;
      // isInformation
      if (this.$route.query.isInformation === 1) {
        setTimeout(()=> {
          this.moveToInformation();
        }, 500);
      }
    }, 1);
  },
  methods: {
    moveToInformation() {
      window.scroll({
        top: this.windowHeight,
        left: 0,
        behavior: "smooth",
      });
    },
    moveToBiography() {
      this.$router.push({ name: Constants.ROUTER.BIOGRAPHY });
    },
    moveToDiscography() {
      this.$router.push({ name: Constants.ROUTER.DISCOGRAPHY });
    },
    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.isTop = window.pageYOffset === 0;
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  },
};
</script>

<template>
  <move-page-on-swipe
    :is-right-move-to="false"
    :left-move-to="leftMoveto"
    class="view-information page"
    :class="[ready ? 'is-ready' : '', $mq]"
  >
    <!--top-->
    <div class="contents-top" :style="{height: windowHeight + 'px'}">
      <div class="top-bg"><div class="top-bg-right"></div></div>
      <div class="logo"></div>
      <div class="whats-news-container">
        <div class="whats-news-bg-right"></div>
        <whats-news/>
        <div class="header-nav wf-gothicfont">
          <div class="is-link" @click="moveToInformation">
            <move-text-hover :target-text="$t('message.information.pageName')" />
          </div>
          <div class="is-link" @click="moveToDiscography">
            <move-text-hover :target-text="$t('message.discography.pageName')" />
          </div>
          <div class="is-link" @click="moveToBiography">
            <move-text-hover :target-text="$t('message.biography.pageName')" />
          </div>
        </div>
      </div>
      
    </div>


    <div id="contents-main">
      <!--宣伝-->
      <div class="promotions-container">

        <demo-booth-banner
          :demo-id="3"
          :booth-url="'https://kyousou-gakudan.booth.pm/items/6853757'"
        />

        <youtube-container-shorts
          :file-url="'1P01VrLK4VE'"
          :is-close-btn-white="true"
        />

        <youtube-container-shorts
          :file-url="'6lNMg9CFyys'"
          :is-close-btn-white="true"
        />
        
        <youtube-container-shorts
          :file-url="'eTLE3KYnT90'"
          :is-close-btn-white="true"
        />
        
        <youtube-container-shorts
          :file-url="'1CPeTWlhcm0'"
          :is-close-btn-white="true"
        />
        
        <youtube-container
          :file-url="'aLeE4xplNsw'"
        />
        
      </div>

      <!--イベント-->
      <common-parallax-item
        class="w100"
        :is-return="false"
      >
        <event-list /> 
      </common-parallax-item>

      <!-- SNSアイコン -->
      <common-parallax-item
        class="w100"
        :is-return="false"
      >
        <div class="sns-container">
          <snsIcons :is-white="true" />
        </div>
      </common-parallax-item>


      <!--SNS-->
      <div class="main-contents">
        <div class="contents twitter">
          <vue-twitter />
        </div>
        <!-- <div class="contents bluesky">
          <vue-bluesky />
        </div> -->
        <!-- <div class="contents twitter">
          <vue-threads />
        </div> -->
        
        <div class="contents f1 cd-slider-container">
          <cd-slider-diamond/>
        </div>
        <div class="contents instagram">
          <vue-instagram :posts="instagramPosts"/>
        </div>
      </div>

      <div class="cd-list-container">
        <cd-list-information/>
      </div>
      
      <div class="demo-cd-container">
        <div class="title wf-gothicfont" :title="$t('message.demo.pageName')">
          {{$t('message.demo.pageName')}}
        </div>
        <demo-cd-list :is-center="true"/>
      </div>

      <!-- <div class="recently-sound-cloud-container">
        <recently-sound-cloud/>
      </div> -->

    </div>


    <common-nav v-if="!isTop" />
    <common-footer/>
    <share-btn :is-fixed="true" v-if="!isTop" />
  </move-page-on-swipe>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .page {
    position: relative;
    .contents-top {
      position: relative;
      display: flex;
      flex-direction:column;

      transition: 1s ease-out;
      filter: blur(10px);
      .top-bg {
        height: 30%;
        width: 100%;
        position: relative;
        background: url(../assets/img/decoration/information01.svg) left top;
        @include bg;
        .top-bg-right {
          background: url(../assets/img/decoration/information01.svg) left top;
          @include bg;
          @include absolute100;
          @include reversalHorizon;
        }
      }
      .logo {
        height: 40%;
        width: 70%;
        margin: 0 auto;
        background-image: url(../assets/img/common/bandLogo.svg);
        @include bgCenter;
        position: relative;

        top: -30px;
        opacity: 0;
        transition: 1s ease-out;
      }
      .whats-news-container {
        width: 100%;
        height: 30%;
        overflow: hidden;
        position: relative;
        .header-nav {
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          display: flex;
          justify-content: center;
          line-height: $commonNavHeight;
          text-align: center;
          .is-link {
            margin: 0 20px;
            :hover {
              color: $accentColor2;
            }
          }
        }
      }
    }
    #contents-main {
      position: relative;
      padding-top: $commonNavHeight;
      .promotions-container {
        width:100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        background: $textColorA50;
        > * {
          margin: 30px 0;
        }
      }

      .sns-container {
        margin: 0 0 20px 0;
      }
      
      .main-contents {
        width: 100%;
        padding: 10px 0;
        justify-content: space-around;
        background: $textColorA50;
        .contents {
          height: 100%;
          padding: 0 10px;
          background-repeat: no-repeat;
          background-size: contain;
          background-attachment: fixed;
        }
        .cd-slider-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .twitter, .instagram, .bluesky {
          margin: 0 auto;
        }
      }

      .cd-list-container {
        width: 100%;
      }
      .demo-cd-container {
        width: 100%;
        padding-bottom: 60px;
        margin-bottom: 60px;
        // color: $bgColor;
        // background: $textColorA50;
        .title {
          font-size: 1.8em;
          margin: 15px 0;
        }
      }
      // .recently-sound-cloud-container {
      //   padding: 100px 0;
      // }
      
    }

    // ------------------------------
    &.is-ready {
      .contents-top {
        filter: blur(0px);
        .logo {
          top: 0px;
          opacity: 1;
        }
      }
    }
    // responsible -----------------------------------------------
    &.viewLg {
      .contents-top {
        .whats-news-container { 
          background: url(../assets/img/decoration/information02.svg) left bottom;
          @include bg;
          > div {
            position: relative;
          }
          .whats-news-bg-right {
            background: url(../assets/img/decoration/information02.svg) left top;
            @include bg;
            @include absolute100;
            @include reversalHorizon;
          }
          .header-nav {
            position: absolute;
            height: $commonNavHeight;
            font-size: 2em;
          }
        }
      }
      #contents-main {
        .main-contents {
          height: 500px;
          display: flex;
          flex-direction: row-reverse;
          .twitter { width: 280px; }
          .instagram { width: 280px; }
          .bluesky { width: 320px; }
        }
      }
    }
    &.viewMd {
      .contents-top {
        .whats-news-container { 
          .header-nav {
            height: $commonNavHeight;
            font-size: 1.3em;
          }
        }
      }
      #contents-main {
        .main-contents {
          .cd-slider-container{
            height: 400px;
            margin: 30px 0;     
          }
          .twitter {
            width: 70%;
            height: 400px;
          }
          .instagram {
            width: 70%;
            height: 400px;
          }
          .bluesky {
            width: 70%;
            height: 400px;
          }
        }
      }
    }
    &.viewSm {
      .contents-top {
        .whats-news-container { 
          .header-nav {
            display: none;
          }
        }
      }
      #contents-main {
        .main-contents {
          .cd-slider-container{
            display: none;
          }
          .twitter {
            width: 100%;
            height: 400px;
            margin-bottom: 50px;
          }
          .bluesky {
            width: 100%;
            height: 400px;
            margin-bottom: 50px;
          }
          .instagram {
            width: 100%;
            height: 400px;
          }
        }
      }
    }
  }
</style>
